import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false
})
export class FooterComponent {
  @Input() isDownload: boolean;
  blobLink = environment.bloblink;
  currentYear: number;
  constructor() {
    this.currentYear = new Date().getFullYear();
  }

}
